import React from 'react';

import '../../styles/components/SettingGearBtn.scss';
import Gear from '../../assets/gearIcon.svg';

export default function SettingGearBtn({ clickHandler }) {
	return (
		<div className='button-container' onClick={() => clickHandler()}>
			<img src={Gear} alt='' />
		</div>
	);
}
